import { render, staticRenderFns } from "./EditReport.vue?vue&type=template&id=4b0c61d6&scoped=true&"
import script from "./EditReport.vue?vue&type=script&lang=js&"
export * from "./EditReport.vue?vue&type=script&lang=js&"
import style0 from "./EditReport.vue?vue&type=style&index=0&id=4b0c61d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c61d6",
  null
  
)

export default component.exports